import { Grid, InputLabel } from '@mui/material';
import React from 'react';
import CustomTextField from '../../../../components/CustomTextField';
import { styleTalentDetails } from '../../styles';

type PropsTableBasicRow = {
  error?: boolean,
  value: string,
  onInputChange?: (e: React.ChangeEvent<HTMLInputElement>) => void,
  name: string,
  label: string,
  viewMode?: ViewMode
};

const TableBasicEditRow = React.forwardRef(
  ({
    error,
    value,
    onInputChange,
    name,
    label,
    viewMode,
  }:PropsTableBasicRow,
  ref: React.ForwardedRef<HTMLInputElement | null>):JSX.Element => {
    return (
      <Grid sx={ styleTalentDetails.cardContent.form.box }
        style={
          {
            backgroundColor: error ?
              styleTalentDetails.cardContent.form.error.backgroundColor : 'unset',
          }
        }
        container
      >
        <Grid item xs={ styleTalentDetails.cardContent.form.boxLabel.xs }>
          <InputLabel
            htmlFor={ name }
            style={ styleTalentDetails.cardContent.form.InputLabel }
          >
            { label }
          </InputLabel>
        </Grid>
        <Grid item xs={ styleTalentDetails.cardContent.form.boxInput.xs }>
          <CustomTextField
            viewMode={ viewMode }
            fullWidth
            inputRef={ ref }
            id={ name }
            variant="standard"
            name={ name  }
            value={ '' || value }
            onChange={ (e: React.ChangeEvent<HTMLInputElement>) => {
              if (onInputChange) {
                onInputChange(e);
              }
            } }
            placeholder=""
            InputProps={ {
              style: styleTalentDetails.cardContent.form.TextField,
              disableUnderline: true,
            } }
          />
        </Grid>
      </Grid>
    );
  });

TableBasicEditRow.displayName = 'TableBasicEditRow';

export default TableBasicEditRow;

TableBasicEditRow.defaultProps = {
  error: false,
  viewMode: 'readonly',
  onInputChange: undefined,
};
